/**
 * URL search parameters used in the FCG application.
 * @enum {string}
 */
export const enum ESearchParams {
  /** Parameter used to indicate invoice edit mode in the URL */
  EditInvoice = 'edit',
}
